module.exports = __webpack_public_path__ + "img/WYSD 2022 Youth Ambassador Badge.d6e5f084.png";